import { setupAnchorLinks } from './anchor-links.ts';
import { setupHiddenLinkText } from './hidden-link-test.ts';
import { setupLazyLoad } from './lazy-load.ts';
import { setupMenu } from './menu.ts';
import { setupStopReferrerHack } from './stop-referrer-hack.ts';
import { setupToggles } from './toggles.ts';

export function setup() {
  setupAnchorLinks();
  setupStopReferrerHack();
  setupToggles();
  setupLazyLoad();
  setupHiddenLinkText();
  setupMenu();
}
